const countriesList = [
	{ label: "", value: "" },
	{ label: "albania", value: "101" },
	{ label: "andorra", value: "102" },
	{ label: "austria", value: "105" },
	{ label: "bulgaria", value: "106" },
	{ label: "cyprus", value: "107" },
	{ label: "denmark", value: "108" },
	{ label: "spain", value: "109" },
	{ label: "finland", value: "110" },
	{ label: "france", value: "111" },
	{ label: "united_kingdom", value: "112" },
	{ label: "luxembourg", value: "113" },
	{ label: "greece", value: "114" },
	{ label: "hungary", value: "115" },
	{ label: "ireland", value: "116" },
	{ label: "iceland", value: "117" },
	{ label: "liechtenstein", value: "118" },
	{ label: "malta", value: "119" },
	{ label: "monaco", value: "120" },
	{ label: "norway", value: "121" },
	{ label: "portugal", value: "123" },
	{ label: "romania", value: "124" },
	{ label: "san_marino", value: "125" },
	{ label: "sweden", value: "126" },
	{ label: "switzerland", value: "127" },
	{ label: "italy", value: "128" },
	{ label: "netherlands", value: "129" },
	{ label: "holy_see", value: "133" },
	{ label: "latvia", value: "135" },
	{ label: "estonia", value: "136" },
	{ label: "lithuania", value: "137" },
	{ label: "poland", value: "139" },
	{ label: "czechia", value: "140" },
	{ label: "slovakia", value: "141" },
	{ label: "belarus", value: "142" },
	{ label: "ukraine", value: "143" },
	{ label: "moldova_republic_of", value: "144" },
	{ label: "russian_federation", value: "145" },
	{ label: "croatia", value: "146" },
	{ label: "slovenia", value: "147" },
	{ label: "macedonia_the_former_yugoslav_republic_of", value: "148" },
	{ label: "bosnia_and_herzegovina", value: "149" },
	{ label: "belgium", value: "150" },
	{ label: "montenegro", value: "151" },
	{ label: "serbia", value: "152" },
	{ label: "kosovo", value: "153" },
	{ label: "germany", value: "173" },
	{ label: "gibraltar", value: "180" },
	{ label: "myanmar", value: "201" },
	{ label: "sri_lanka", value: "203" },
	{ label: "taiwan_province_of_china", value: "204" },
	{ label: "singapore", value: "205" },
	{ label: "korea_republic_of", value: "206" },
	{ label: "india", value: "207" },
	{ label: "indonesia", value: "208" },
	{ label: "japan", value: "209" },
	{ label: "lao_people_s_democratic_republic", value: "210" },
	{ label: "malaysia", value: "212" },
	{ label: "nepal", value: "213" },
	{ label: "philippines", value: "214" },
	{ label: "timor-leste", value: "215" },
	{ label: "cambodia", value: "216" },
	{ label: "china", value: "218" },
	{ label: "korea_democratic_people_s_republic_of", value: "219" },
	{ label: "viet_nam", value: "220" },
	{ label: "mongolia", value: "221" },
	{ label: "maldives", value: "222" },
	{ label: "bhutan", value: "223" },
	{ label: "brunei_darussalam", value: "224" },
	{ label: "kazakhstan", value: "225" },
	{ label: "kyrgyzstan", value: "226" },
	{ label: "uzbekistan", value: "227" },
	{ label: "tajikistan", value: "228" },
	{ label: "thailand", value: "235" },
	{ label: "bangladesh", value: "237" },
	{ label: "armenia", value: "249" },
	{ label: "azerbaijan", value: "250" },
	{ label: "afghanistan", value: "251" },
	{ label: "saudi_arabia", value: "252" },
	{ label: "georgia", value: "253" },
	{ label: "iraq", value: "254" },
	{ label: "iran", value: "255" },
	{ label: "israel", value: "256" },
	{ label: "jordan", value: "257" },
	{ label: "lebanon", value: "258" },
	{ label: "pakistan", value: "259" },
	{ label: "united_arab_emirates", value: "260" },
	{ label: "syrian_arab_republic", value: "261" },
	{ label: "turkey", value: "262" },
	{ label: "kuwait", value: "264" },
	{ label: "oman", value: "266" },
	{ label: "qatar", value: "267" },
	{ label: "bahrein", value: "268" },
	{ label: "yemen", value: "270" },
	{ label: "hong_kong", value: "280" },
	{ label: "macao", value: "281" },
	{ label: "timor", value: "282" },
	{ label: "palestine_state_of", value: "283" },
	{ label: "lesotho", value: "301" },
	{ label: "botswana", value: "302" },
	{ label: "burundi", value: "303" },
	{ label: "cameroon", value: "304" },
	{ label: "central_african_republic", value: "305" },
	{ label: "congo_the_democratic_republic_of_the", value: "306" },
	{ label: "congo", value: "307" },
	{ label: "burkinafaso", value: "308" },
	{ label: "ivory_coast", value: "309" },
	{ label: "benin", value: "310" },
	{ label: "ethiopia", value: "311" },
	{ label: "gabon", value: "312" },
	{ label: "gambia", value: "313" },
	{ label: "ghana", value: "314" },
	{ label: "guinea", value: "315" },
	{ label: "mauritius", value: "317" },
	{ label: "liberia", value: "318" },
	{ label: "mali", value: "319" },
	{ label: "senegal", value: "320" },
	{ label: "niger", value: "321" },
	{ label: "nigeria", value: "322" },
	{ label: "uganda", value: "323" },
	{ label: "madagascar", value: "324" },
	{ label: "sierra_leone", value: "328" },
	{ label: "somalia", value: "329" },
	{ label: "tanzania", value: "332" },
	{ label: "dhad", value: "333" },
	{ label: "togo", value: "334" },
	{ label: "zambia", value: "335" },
	{ label: "kenya", value: "336" },
	{ label: "equatorial_guinea", value: "337" },
	{ label: "guinea-bissau", value: "338" },
	{ label: "zimbabwe", value: "344" },
	{ label: "djibouti", value: "345" },
	{ label: "sao_tome_and_principe", value: "346" },
	{ label: "eritrea", value: "349" },
	{ label: "algeria", value: "351" },
	{ label: "egypt", value: "352" },
	{ label: "libyan", value: "353" },
	{ label: "morocco", value: "354" },
	{ label: "mauritania", value: "355" },
	{ label: "sudan", value: "356" },
	{ label: "tunisia", value: "357" },
	{ label: "malawi", value: "358" },
	{ label: "rwanda", value: "360" },
	{ label: "south_sudan", value: "365" },
	{ label: "angola", value: "381" },
	{ label: "mozambique", value: "383" },
	{ label: "namibia", value: "384" },
	{ label: "cabo_verde", value: "385" },
	{ label: "comoros", value: "386" },
	{ label: "reunion", value: "387" },
	{ label: "western_sahara", value: "388" },
	{ label: "seychelles(Eilanden)", value: "390" },
	{ label: "swaziland", value: "395" },
	{ label: "canada", value: "401" },
	{ label: "united_states_of_america", value: "402" },
	{ label: "costa_rica", value: "411" },
	{ label: "cuba", value: "412" },
	{ label: "guatemala", value: "413" },
	{ label: "honduras", value: "414" },
	{ label: "jamaica", value: "415" },
	{ label: "mexico", value: "416" },
	{ label: "nicaragua", value: "417" },
	{ label: "panama", value: "418" },
	{ label: "haiti", value: "419" },
	{ label: "dominican_republic", value: "420" },
	{ label: "el_salvador", value: "421" },
	{ label: "trinidad_and_tobago", value: "422" },
	{ label: "barbados", value: "423" },
	{ label: "grenada", value: "426" },
	{ label: "saint_lucia", value: "428" },
	{ label: "saint_vincent_and_the_grenadines", value: "429" },
	{ label: "belize", value: "430" },
	{ label: "saint_kitts_and_nevis", value: "431" },
	{ label: "virgin_islands_us", value: "478" },
	{ label: "virgin_islands_british", value: "479" },
	{ label: "dominica", value: "480" },
	{ label: "bahamas", value: "484" },
	{ label: "bermuda", value: "485" },
	{ label: "puerto_rico", value: "487" },
	{ label: "turks_and_caicos_islands", value: "488" },
	{ label: "antigua_and_barbuda", value: "491" },
	{ label: "cayman_islands", value: "492" },
	{ label: "montserrat", value: "493" },
	{ label: "saint_pierre_and_miquelon", value: "495" },
	{ label: "guadeloupe", value: "496" },
	{ label: "martinique", value: "497" },
	{ label: "greenland", value: "498" },
	{ label: "saint_barthelemy", value: "499" },
	{ label: "argentina", value: "511" },
	{ label: "bolivia", value: "512" },
	{ label: "brazil", value: "513" },
	{ label: "chile", value: "514" },
	{ label: "columbia", value: "515" },
	{ label: "ecuador", value: "516" },
	{ label: "paraguay", value: "517" },
	{ label: "peru", value: "518" },
	{ label: "uruguay", value: "519" },
	{ label: "venezuela", value: "520" },
	{ label: "guyana", value: "521" },
	{ label: "suriname", value: "522" },
	{ label: "falkland_islands_malvinas", value: "580" },
	{ label: "french_guiana", value: "581" },
	{ label: "micronesia_federated_states_of", value: "602" },
	{ label: "marshall_islands", value: "603" },
	{ label: "niue", value: "604" },
	{ label: "cook_islands", value: "605" },
	{ label: "australia", value: "611" },
	{ label: "new_zealand", value: "613" },
	{ label: "samoa", value: "614" },
	{ label: "nauru", value: "615" },
	{ label: "tonga", value: "616" },
	{ label: "fiji", value: "617" },
	{ label: "papua_new_guinea", value: "619" },
	{ label: "tuvalu", value: "621" },
	{ label: "kiribati", value: "622" },
	{ label: "solomon_islands", value: "623" },
	{ label: "vanuatu", value: "624" },
	{ label: "palau", value: "679" },
	{ label: "guam", value: "681" },
	{ label: "new_caledonia", value: "683" },
	{ label: "french_polynesia", value: "688" },
	{ label: "wallis_and_futuna(FR)", value: "689" },
	{ label: "american_samoa", value: "690" },
	{ label: "pitcairn", value: "692" },
	{ label: "refugee", value: "700" },
	{ label: "undefined", value: "711" },
	{ label: "unknown", value: "999" },
]
const nationalitiesList = [
	{ label: "albania", value: "101" },
	{ label: "andorra", value: "102" },
	{ label: "austria", value: "105" },
	{ label: "bulgaria", value: "106" },
	{ label: "cyprus", value: "107" },
	{ label: "denmark", value: "108" },
	{ label: "spain", value: "109" },
	{ label: "finland", value: "110" },
	{ label: "france", value: "111" },
	{ label: "united_kingdom", value: "112" },
	{ label: "luxembourg", value: "113" },
	{ label: "greece", value: "114" },
	{ label: "hungary", value: "115" },
	{ label: "ireland", value: "116" },
	{ label: "iceland", value: "117" },
	{ label: "liechtenstein", value: "118" },
	{ label: "malta", value: "119" },
	{ label: "monaco", value: "120" },
	{ label: "norway", value: "121" },
	{ label: "portugal", value: "123" },
	{ label: "romania", value: "124" },
	{ label: "san_marino", value: "125" },
	{ label: "sweden", value: "126" },
	{ label: "switzerland", value: "127" },
	{ label: "italy", value: "128" },
	{ label: "netherlands", value: "129" },
	{ label: "holy_see", value: "133" },
	{ label: "latvia", value: "135" },
	{ label: "estonia", value: "136" },
	{ label: "lithuania", value: "137" },
	{ label: "poland", value: "139" },
	{ label: "czechia", value: "140" },
	{ label: "slovakia", value: "141" },
	{ label: "belarus", value: "142" },
	{ label: "ukraine", value: "143" },
	{ label: "moldova_republic_of", value: "144" },
	{ label: "russian_federation", value: "145" },
	{ label: "croatia", value: "146" },
	{ label: "slovenia", value: "147" },
	{ label: "macedonia_the_former_yugoslav_republic_of", value: "148" },
	{ label: "bosnia_and_herzegovina", value: "149" },
	{ label: "belgium", value: "150" },
	{ label: "montenegro", value: "151" },
	{ label: "serbia", value: "152" },
	{ label: "kosovo", value: "153" },
	{ label: "germany", value: "173" },
	{ label: "gibraltar", value: "180" },
	{ label: "myanmar", value: "201" },
	{ label: "sri_lanka", value: "203" },
	{ label: "taiwan_province_of_china", value: "204" },
	{ label: "singapore", value: "205" },
	{ label: "korea_republic_of", value: "206" },
	{ label: "india", value: "207" },
	{ label: "indonesia", value: "208" },
	{ label: "japan", value: "209" },
	{ label: "lao_people_s_democratic_republic", value: "210" },
	{ label: "malaysia", value: "212" },
	{ label: "nepal", value: "213" },
	{ label: "philippines", value: "214" },
	{ label: "timor-leste", value: "215" },
	{ label: "cambodia", value: "216" },
	{ label: "china", value: "218" },
	{ label: "korea_democratic_people_s_republic_of", value: "219" },
	{ label: "viet_nam", value: "220" },
	{ label: "mongolia", value: "221" },
	{ label: "maldives", value: "222" },
	{ label: "bhutan", value: "223" },
	{ label: "brunei_darussalam", value: "224" },
	{ label: "kazakhstan", value: "225" },
	{ label: "kyrgyzstan", value: "226" },
	{ label: "uzbekistan", value: "227" },
	{ label: "tajikistan", value: "228" },
	{ label: "thailand", value: "235" },
	{ label: "bangladesh", value: "237" },
	{ label: "armenia", value: "249" },
	{ label: "azerbaijan", value: "250" },
	{ label: "afghanistan", value: "251" },
	{ label: "saudi_arabia", value: "252" },
	{ label: "georgia", value: "253" },
	{ label: "iraq", value: "254" },
	{ label: "iran", value: "255" },
	{ label: "israel", value: "256" },
	{ label: "jordan", value: "257" },
	{ label: "lebanon", value: "258" },
	{ label: "pakistan", value: "259" },
	{ label: "united_arab_emirates", value: "260" },
	{ label: "syrian_arab_republic", value: "261" },
	{ label: "turkey", value: "262" },
	{ label: "kuwait", value: "264" },
	{ label: "oman", value: "266" },
	{ label: "qatar", value: "267" },
	{ label: "bahrein", value: "268" },
	{ label: "yemen", value: "270" },
	{ label: "hong_kong", value: "280" },
	{ label: "macao", value: "281" },
	{ label: "timor", value: "282" },
	{ label: "palestine_state_of", value: "283" },
	{ label: "lesotho", value: "301" },
	{ label: "botswana", value: "302" },
	{ label: "burundi", value: "303" },
	{ label: "cameroon", value: "304" },
	{ label: "central_african_republic", value: "305" },
	{ label: "congo_the_democratic_republic_of_the", value: "306" },
	{ label: "congo", value: "307" },
	{ label: "burkinafaso", value: "308" },
	{ label: "ivory_coast", value: "309" },
	{ label: "benin", value: "310" },
	{ label: "ethiopia", value: "311" },
	{ label: "gabon", value: "312" },
	{ label: "gambia", value: "313" },
	{ label: "ghana", value: "314" },
	{ label: "guinea", value: "315" },
	{ label: "mauritius", value: "317" },
	{ label: "liberia", value: "318" },
	{ label: "mali", value: "319" },
	{ label: "senegal", value: "320" },
	{ label: "niger", value: "321" },
	{ label: "nigeria", value: "322" },
	{ label: "uganda", value: "323" },
	{ label: "madagascar", value: "324" },
	{ label: "sierra_leone", value: "328" },
	{ label: "somalia", value: "329" },
	{ label: "tanzania", value: "332" },
	{ label: "dhad", value: "333" },
	{ label: "togo", value: "334" },
	{ label: "zambia", value: "335" },
	{ label: "kenya", value: "336" },
	{ label: "equatorial_guinea", value: "337" },
	{ label: "guinea-bissau", value: "338" },
	{ label: "zimbabwe", value: "344" },
	{ label: "djibouti", value: "345" },
	{ label: "sao_tome_and_principe", value: "346" },
	{ label: "eritrea", value: "349" },
	{ label: "algeria", value: "351" },
	{ label: "egypt", value: "352" },
	{ label: "libyan", value: "353" },
	{ label: "morocco", value: "354" },
	{ label: "mauritania", value: "355" },
	{ label: "sudan", value: "356" },
	{ label: "tunisia", value: "357" },
	{ label: "malawi", value: "358" },
	{ label: "rwanda", value: "360" },
	{ label: "south_sudan", value: "365" },
	{ label: "angola", value: "381" },
	{ label: "mozambique", value: "383" },
	{ label: "namibia", value: "384" },
	{ label: "cabo_verde", value: "385" },
	{ label: "comoros", value: "386" },
	{ label: "reunion", value: "387" },
	{ label: "western_sahara", value: "388" },
	{ label: "seychelles(Eilanden)", value: "390" },
	{ label: "swaziland", value: "395" },
	{ label: "canada", value: "401" },
	{ label: "united_states_of_america", value: "402" },
	{ label: "costa_rica", value: "411" },
	{ label: "cuba", value: "412" },
	{ label: "guatemala", value: "413" },
	{ label: "honduras", value: "414" },
	{ label: "jamaica", value: "415" },
	{ label: "mexico", value: "416" },
	{ label: "nicaragua", value: "417" },
	{ label: "panama", value: "418" },
	{ label: "haiti", value: "419" },
	{ label: "dominican_republic", value: "420" },
	{ label: "el_salvador", value: "421" },
	{ label: "trinidad_and_tobago", value: "422" },
	{ label: "barbados", value: "423" },
	{ label: "grenada", value: "426" },
	{ label: "saint_lucia", value: "428" },
	{ label: "saint_vincent_and_the_grenadines", value: "429" },
	{ label: "belize", value: "430" },
	{ label: "saint_kitts_and_nevis", value: "431" },
	{ label: "virgin_islands_us", value: "478" },
	{ label: "virgin_islands_british", value: "479" },
	{ label: "dominica", value: "480" },
	{ label: "bahamas", value: "484" },
	{ label: "bermuda", value: "485" },
	{ label: "puerto_rico", value: "487" },
	{ label: "turks_and_caicos_islands", value: "488" },
	{ label: "antigua_and_barbuda", value: "491" },
	{ label: "cayman_islands", value: "492" },
	{ label: "montserrat", value: "493" },
	{ label: "saint_pierre_and_miquelon", value: "495" },
	{ label: "guadeloupe", value: "496" },
	{ label: "martinique", value: "497" },
	{ label: "greenland", value: "498" },
	{ label: "saint_barthelemy", value: "499" },
	{ label: "argentina", value: "511" },
	{ label: "bolivia", value: "512" },
	{ label: "brazil", value: "513" },
	{ label: "chile", value: "514" },
	{ label: "columbia", value: "515" },
	{ label: "ecuador", value: "516" },
	{ label: "paraguay", value: "517" },
	{ label: "peru", value: "518" },
	{ label: "uruguay", value: "519" },
	{ label: "venezuela", value: "520" },
	{ label: "guyana", value: "521" },
	{ label: "suriname", value: "522" },
	{ label: "falkland_islands_malvinas", value: "580" },
	{ label: "french_guiana", value: "581" },
	{ label: "micronesia_federated_states_of", value: "602" },
	{ label: "marshall_islands", value: "603" },
	{ label: "niue", value: "604" },
	{ label: "cook_islands", value: "605" },
	{ label: "australia", value: "611" },
	{ label: "new_zealand", value: "613" },
	{ label: "samoa", value: "614" },
	{ label: "nauru", value: "615" },
	{ label: "tonga", value: "616" },
	{ label: "fiji", value: "617" },
	{ label: "papua_new_guinea", value: "619" },
	{ label: "tuvalu", value: "621" },
	{ label: "kiribati", value: "622" },
	{ label: "solomon_islands", value: "623" },
	{ label: "vanuatu", value: "624" },
	{ label: "palau", value: "679" },
	{ label: "guam", value: "681" },
	{ label: "new_caledonia", value: "683" },
	{ label: "french_polynesia", value: "688" },
	{ label: "wallis_and_futuna(FR)", value: "689" },
	{ label: "american_samoa", value: "690" },
	{ label: "pitcairn", value: "692" },
	{ label: "refugee", value: "700" },
	{ label: "undefined", value: "711" },
	{ label: "unknown", value: "999" },
]

export default [
	{
		categoryName: "identification",
		inputs: [
			{
				label: "date_of_birth",
				inputType: "datepicker",
				required: false,
			},
			{
				label: "place_of_birth_name",
				inputType: "text",
				required: false,
			},
			{
				label: "country_of_birth_name",
				inputType: "select",
				required: false,
				skipOptionsTranslationPrefix: true,
				options: countriesList,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.country_of_birth_name || currentWorker.country_of_birth_name,
			},
			{
				label: "nationality",
				inputType: "select",
				required: false,
				skipOptionsTranslationPrefix: true,
				options: nationalitiesList,
			},
			{
				label: "landline_country_code",
				inputType: "text",
				required: false,
			},
			{
				label: "landline_number",
				inputType: "text",
				required: false,
			},
			{
				label: "official_language_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "nl", value: "NL" },
					{ label: "fr", value: "FR" },
					{ label: "de", value: "DE" },
					{ label: "en", value: "EN" },
				],
				secSocPrefillable: true,
				skipTranslationPrefix: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.official_language_code || currentWorker.official_language_code,
			},
			{
				label: "marital_status_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "marital_status_single", value: "01" },
					{ label: "married", value: "02" },
					{ label: "marital_status_widow", value: "03" },
					{ label: "separated", value: "04" },
					{ label: "divorced", value: "05" },
					{ label: "legally_separated", value: "06" },
					{ label: "legally_cohabiting", value: "07" },
				],
				secSocPrefillable: false,
			},
			{
				label: "education_degree_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "elementary_education", value: "01" },
					{ label: "secondary_education", value: "02" },
					{ label: "higher_non_univ_education", value: "03" },
					{ label: "high_university_education", value: "04" },
					{ label: "elementary_education_or_no_education", value: "11" },
					{ label: "lower_sec_ed_sp_ed_1_3", value: "12" },
					{ label: "second_year_3rd_grade_vocational_sec_ed", value: "21" },
					{ label: "third_gr_ts_ase_vse", value: "22" },
					{ label: "third_grade_sec_ed", value: "23" },
					{ label: "part_time_technical_ed", value: "24" },
					{ label: "part_time_vocational_sec_ed_higher_sec_ed", value: "25" },
					{ label: "sse_4_without_certificate_or_diploma", value: "26" },
					{ label: "seventh_y_vse_w_dip_se_cert", value: "27" },
					{ label: "higher_non_univ_education_short", value: "31" },
					{ label: "higher_non_univ_education_long", value: "32" },
					{ label: "university_education", value: "41" },
					{ label: "post_university_education", value: "42" },
					{ label: "phd_with_thesis", value: "43" },
				],
			},
			{
				label: "graduation_year",
				inputType: "text",
				required: false,
			},
		],
	},
	{
		categoryName: "contract",
		inputs: [
			{
				label: "iban",
				inputType: "text",
				required: false,
			},
			{
				label: "workschedule_type_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "fixed", value: "1" },
					{ label: "variable", value: "2" },
					{ label: "none", value: "3" },
					{ label: "fixed_with_time_registration", value: "4" },
					{ label: "variable_with_time_registration", value: "5" },
				],
			},
			{
				label: "statute_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "contractual", value: "01" },
					{ label: "temporary", value: "02" },
					{ label: "permanent_contract", value: "03" },
					{ label: "mandatary", value: "04" },
					{ label: "company_manager", value: "05" },
					{ label: "director", value: "06" },
					{ label: "manager_non_profit", value: "09" },
					{ label: "pensioner", value: "10" },
					{ label: "early_retiree", value: "11" },
					{ label: "widow", value: "12" },
					{ label: "orphan", value: "13" },
					{ label: "military_reserve", value: "14" },
					{ label: "volunteer", value: "16" },
					{ label: "unemployed", value: "17" },
					{ label: "pfi_stage", value: "18" },
					{ label: "time_credit_canada_dry", value: "19" },
					{ label: "unemployed_canada_dry", value: "20" },
					{ label: "professional_initiation", value: "21" },
				],
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.statute_code || currentWorker.statute_code,
			},
			{
				label: "duration_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "indefinite_time", value: "01" },
					{ label: "definite_time", value: "02" },
					{ label: "well_defined_work", value: "03" },
					{ label: "replacement_contract", value: "04" },
					{ label: "limited_performances", value: "05" },
					{ label: "blue_white_collar_with_intervals", value: "06" },
					{ label: "seasonal_work_peak_extra_day_lump_sum", value: "07" },
					{ label: "definite_time_over_3_months_clerk_cat_1", value: "08" },
					{ label: "definite_time_over_3_months_clerk_cat_2", value: "09" },
					{ label: "well_defined_work_under_3_months", value: "10" },
					{ label: "well_defined_work_over_3_months", value: "11" },
					{ label: "replacement_contract_under_3_months", value: "12" },
					{ label: "replacement_contract_over_3_months", value: "13" },
					{ label: "seasonal_blue_collar_without_daily_lump", value: "14" },
					{ label: "definite_time_under_3_months", value: "15" },
					{ label: "flexi_with_dimona_period", value: "16" },
					{ label: "flexi_with_daily_dimona", value: "17" },
					{ label: "flexi_refused", value: "18" },
					{ label: "none", value: "99" },
				],
				secSocPrefillable: false,
			},
			{
				label: "service_receiver_official_joint_committee_code",
				inputType: "select",
				required: false,
				options: [
					{
						label: "accr_co_providing_community_work_or_services",
						value: "322010",
					},
				],
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.service_receiver_official_joint_committee_code ||
					currentWorker.service_receiver_official_joint_committee_code,
			},
			{
				label: "employee_group",
				inputType: "text",
				required: false,
			},
			{
				label: "work_fraction",
				inputType: "text",
				required: false,
			},
			{
				label: "reference_person",
				inputType: "text",
				required: false,
			},
			{
				label: "workplace",
				inputType: "text",
				required: false,
			},
		],
	},
	{
		categoryName: "profession",
		inputs: [
			{
				label: "profession",
				inputType: "text",
				required: false,
			},
		],
	},
	{
		categoryName: "partner",
		show: values => ["02", "04", "07"].includes(values["marital_status_code"]),
		inputs: [
			{
				label: "partner_first_name",
				inputType: "text",
				required: false,
			},
			{
				label: "partner_last_name",
				inputType: "text",
				required: false,
			},
			{
				label: "partner_disabled_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "yes", value: "1" },
					{ label: "no", value: "0" },
				],
			},
			{
				label: "partner_profession_code",
				inputType: "select",
				required: false,
				options: [
					{ label: "single", value: "00" },
					{ label: "spouse_with_normal_prof", value: "01" },
					{ label: "spouse_with_pension", value: "02" },
					{ label: "spouse_eec", value: "03" },
					{ label: "spouse_with_professional_income", value: "08" },
					{ label: "spouse_without_professional_income", value: "09" },
				],
				secSocPrefillable: false,
			},
			{
				label: "partner_birth_date",
				inputType: "datepicker",
				required: false,
			},
		],
	},
	{
		categoryName: "withholdingtaxes",
		inputs: [
			{
				label: "number_of_dependant_children",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_dependant_children ||
					currentWorker.number_of_dependant_children,
			},
			{
				label: "number_of_disabled_dependant_children",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_disabled_dependant_children ||
					currentWorker.number_of_disabled_dependant_children,
			},
			{
				label: "number_of_other_dependants",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_other_dependants ||
					currentWorker.number_of_other_dependants,
			},
			{
				label: "number_of_other_disabled_dependants",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_other_disabled_dependants ||
					currentWorker.number_of_other_disabled_dependants,
			},
			{
				label: "number_of_dependants_over_65",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_dependants_over_65 ||
					currentWorker.number_of_dependants_over_65,
			},
			{
				label: "number_of_disabled_dependants_over_65",
				inputType: "text",
				required: false,
				skipTranslationPrefix: true,
				secSocPrefillable: true,
				default: (currentWorker, secSocPrefill) =>
					secSocPrefill.number_of_disabled_dependants_over_65 ||
					currentWorker.number_of_disabled_dependants_over_65,
			},
		],
	},
	{
		categoryName: "salary",
		inputs: [
			{
				label: "gross_salary",
				inputType: "text",
				required: false,
			},
			{
				label: "salary_unit",
				inputType: "text",
				required: false,
			},
		],
	},
]
